module.exports = __webpack_public_path__ + "static/media/skip_next-24px.7f000d70.svg";